const userDataFormES = {
    "view": {
        "title": "Complete su Información",
        "stepZero": {
            "title": "Declaración",
            "form": {
                "label": {
                    "declarationPoint1": "Al proporcionar esta información, usted reconoce y acepta que será proporcionada al mejor de su conocimiento y capacidad. Nos esforzamos por garantizar que toda la información sea precisa y veraz.",
                    "declarationPoint2": "Tenga en cuenta que proporcionar información falsa o tergiversar la verdad puede tener consecuencias significativas. Instamos a todos los usuarios a verificar la información que proporcionan y a utilizar esta plataforma de manera responsable.",
                    "declarationPoint3": "La responsabilidad por cualquier información errónea o errores recae únicamente en la persona que proporciona la información. No asumimos ninguna responsabilidad por las consecuencias de la información incorrecta o engañosa proporcionada por los usuarios.",
                    "declarationPoint4": "Al hacer clic en <strong>'Siguiente'</strong>, usted acepta estos términos y afirma que está completamente consciente de las implicaciones de proporcionar información inexacta o falsa.",
                    "declarationAgreement": "Estoy completamente de acuerdo y entiendo los términos anteriores."
                },
                "button": {
                    "next": "Siguiente"
                }
            }
        },
        "stepOne": {
            "title": "Información Personal",
            "form": {
                "label": {
                    "firstName": "Nombre",
                    "lastName": "Apellido",
                    "streetAndNumber": "Calle y Número",
                    "zipCode": "Código Postal",
                    "city": "Ciudad",
                    "country": "País"
                },
                "placeholder": {
                    "country": "Seleccionar País"
                },
                "help_text": {
                    "firstName": "Si se registra como una LLC u otra entidad comercial, este campo se utilizará para el Nombre del CEO.",
                    "lastName": "Si se registra como una LLC u otra entidad comercial, este campo se utilizará para el Apellido del CEO.",
                    "country": "Si se registra como una LLC u otra entidad comercial, este campo se utilizará para el País del CEO."
                },
                "button": {
                    "next": "Siguiente"
                }
            }
        },
        "stepTwo": {
            "title": "Información Comercial",
            "form": {
                "label": {
                    "businessType": "Tipo de Negocio",
                    "companyName": "Nombre de la Empresa",
                    "businessStreet": "Calle y Número",
                    "businessCity": "Ciudad",
                    "businessZip": "Código Postal",
                    "businessCountry": "País",
                    "ceoFirstName": "Representante Legal / Nombre del CEO",
                    "ceoLastName": "Representante Legal / Apellido del CEO",
                    "tradeRegistryExport": "Exportación del Registro Mercantil",
                    "tradeRegistryCompanyUrl": "URL del Registro Mercantil de la Empresa",
                    "vatNumber": "Número de IVA",
                    "taxNumber": "Número de Impuesto"
                },
                "option": {
                    "businessType": {
                        "soleProprietorship": "Propietario único",
                        "limitedLiabilityCompany": "Sociedad de responsabilidad limitada",
                        "partnershipOrganized": "Sociedad organizada",
                        "publicLimitedCompanyByShares": "Sociedad anónima por acciones",
                        "other": "Otro"
                    }
                },
                "placeholder": {
                    "businessType": "Seleccionar Tipo de Negocio",
                    "businessCountry": "Seleccionar País"
                },
                "help_text": {
                    "companyName": "El nombre de la empresa debe ser consistente con lo que se presentó inicialmente en Stripe. Solo cambie si difiere de lo que se presentó inicialmente.",
                    "tradeRegistryExport": "Por favor, proporcione una exportación oficial del registro mercantil de su empresa. Solo PDF, tamaño máximo de archivo 5 MB. Si necesita ayuda para encontrar su exportación del registro mercantil, comuníquese con el registro en su país. Una lista no oficial de los registros se puede encontrar <1>aquí</1>.",
                    "tradeRegistryCompanyUrl": "Por favor, proporcione la URL de su empresa en el registro mercantil de su país. Si su registro no admite esto, inserte solo una URL del registro."
                },
                "button": {
                    "previous": "Anterior",
                    "next": "Siguiente"
                }
            }
        },
        "stepThree": {
            "title": "Confirmación",
            "form": {
                "label": {
                    "personalInformation": "Información Personal",
                    "personalName": "Nombre",
                    "personalAddress": "Dirección",
                    "businessInformation": "Información Comercial",
                    "companyName": "Empresa",
                    "ceoName": "Nombre del CEO",
                    "businessAddress": "Dirección",
                    "businessType": "Tipo de Negocio",
                    "taxNumber": "Número de Impuesto",
                    "vatNumber": "Número de IVA",
                    "tradeRegistryExportUploaded": "Exportación del Registro Mercantil Subida",
                    "tradeRegistryCompanyUrl": "URL del Registro Mercantil de la Empresa",
                    "notAvailable": "N/A"
                },
                "button": {
                    "previous": "Anterior",
                    "save": "Guardar",
                    "next": "Siguiente"
                }
            },
            "message": {
                "success": "¡Su información ha sido actualizada!",
                "error": "¡Algo salió mal! ¡Por favor, actualice la página e intente de nuevo!"
            },
            "modal": {
                "submitYourInformation": {
                    "header": "Enviar su Información",
                    "body": {
                        "point1": "Al hacer clic en <strong>'Confirmar'</strong>, usted afirma que toda la información que ha proporcionado es precisa y veraz al mejor de su conocimiento.",
                        "point2": "¿Confirma que todos los detalles proporcionados son correctos y reconoce las posibles consecuencias de enviar información inexacta?"
                    },
                    "button": {
                        "confirm": "Confirmar",
                        "cancel": "Cancelar"
                    }
                }
            }
        },
        "stepFour": {
            "title": "Verificar Número de Móvil",
            "form": {
                "label": {
                    "mobileNumber": "Ingrese su Número de Móvil",
                    "deliveryMedium": "Medio de Entrega: ",
                    "deliveryMediumSMS": "SMS",
                    "deliveryMediumWhatsapp": "WhatsApp",
                    "otp": "OTP"
                },
                "help_text": {
                    "mobileNumber": "Nota: Se requiere el número de móvil para la verificación como procedimiento estándar porque se puede usar para la validación de inicio de sesión. Necesita ser dueño del número y tener acceso a él para un proceso de verificación sin problemas.",
                    "isFormUSorCanada": "* Si está basado en EE. UU. o Canadá, comuníquese con nuestro equipo de soporte después de insertar su número de móvil.",
                    "deliveryMediumWhatsapp": "Nota: Asegúrese de tener una cuenta de WhatsApp en este número para recibir el mensaje.",
                    "otp": "Por favor, ingrese el OTP enviado a su número de móvil."
                },
                "message": {
                    "errorMobileNumberEmpty": "Se requiere el número de móvil.",
                    "errorMobileNumberInvalid": "Número de móvil inválido.",
                    "errorMobileNumberSame": "Este número ya está agregado y verificado con su cuenta.",
                    "errorOTPRequired": "Se requiere OTP.",
                    "errorOtpSendLimitExhasuted": "No puede solicitar más OTP ya que ha agotado el <strong>límite MÁXIMO ({{maxLimit}})</strong> para solicitudes de OTP. ¡Por favor, contacte al soporte para más información!",
                    "errorMobileUpdateLimitExhausted": "No puede actualizar su número de móvil ya que ya lo ha actualizado el MÁXIMO ({{maxLimit}}) de veces. ¡Por favor, contacte al soporte para más información!"
                },
                "button": {
                    "sendOTP": "Enviar OTP",
                    "next": "Siguiente",
                    "confirm": "Confirmar",
                    "notGettingCode": "No estoy recibiendo el código"
                }
            },
            "message": {
                "success": "¡Número de móvil verificado!",
                "errorValidatingOTP": "¡Error al validar OTP!",
                "errorSendingOTP": "Hubo un problema al enviar el código OTP, ¡intente nuevamente más tarde!"
            },
            "modal": {
                "notGettingCode": {
                    "header": "No estoy recibiendo el código",
                    "body": {
                        "point1": "Parece que hay un problema enviándole un código de verificación en este momento. Por favor, intente nuevamente más tarde",
                        "point2": "Para obtener ayuda, comuníquese con nuestro soporte a través del Centro de Ayuda."
                    },
                    "button": {
                        "close": "Cerrar"
                    }
                }
            },
            "resendTimer": {
                "message": {
                    "secondsRemaining": "Puede solicitar el OTP nuevamente en <strong>{{secondsRemaining}}</strong> segundos"
                }
            }
        },
        "stepFive": {
            "title": "Verificación de Identidad",
            "form": {
                "label": {
                    "identityVerificationDescription": "Por favor, haga clic en el enlace a continuación para comenzar la Verificación de Identidad.",
                    "identityVerificationResults": "Resultados de la Verificación de Identidad"
                },
                "button": {
                    "loading": "Cargando...",
                    "verifyIdentity": "Verificar Identidad"
                },
                "table": {
                    "column": {
                        "type": "Tipo",
                        "status": "Estado",
                        "details": "Detalles"
                    },
                    "label": {
                        "selfieVerification": "Verificación de Selfie",
                        "documentVerification": "Verificación de Documento",
                        "verified": "Verificado",
                        "notVerified": "No Verificado",
                        "notAvailable": "N/A"
                    }
                },
                "message": {
                    "identityVerificationSuccess": "Su información de identidad ha sido verificada, nuestro equipo revisará la información de identidad y dará la aprobación final en 2-3 días hábiles.",
                    "identityVerificationFailed": "Su información de identidad no pudo ser verificada, ¡por favor envíe la información nuevamente! Solo le queda <strong>{{attemptsRemaining}}</strong> intento para verificar su identidad.",
                    "identityVerificationMaxAttempts": "Ha agotado el número máximo de intentos para la Verificación de Identidad, por favor contacte al soporte para más información."
                }
            }
        },
        "stepSix": {
            "title": "Firmar Contrato",
            "form": {
                "label": {
                    "signContract": "Firmar Contrato"
                }
            }
        },
        "stepSeven": {
            "title": "Aprobación",
            "form": {
                "message": {
                    "approval": "Nuestro equipo revisará toda la información proporcionada por usted y dará la aprobación final dentro de 3 días hábiles."
                }
            }
        }
    },
    "signRedirectPages": {
        "signSuccess": {
            "title": "Firma de Contrato Exitosa :)",
            "description": "Ha firmado su contrato con éxito, el estado se actualizará en su cuenta en breve, por favor actualice la página en unos segundos."
        },
        "signLater": {
            "title": "Firma de Contrato Más Tarde ...",
            "description": "Ha elegido firmar el contrato más tarde, por favor complete este paso lo antes posible para poder distribuir."
        },
        "signDeclined": {
            "title": "Firma de Contrato Rechazada :(",
            "description": "Ha rechazado firmar el contrato, esto retrasará el proceso para habilitar la distribución."
        },
        "signCompleted": {
            "title": "Firma de Contrato Completada :)",
            "description": "Su contrato ha sido finalizado, el estado se actualizará en su cuenta en breve, por favor actualice la página en unos segundos."
        }
    }
};

export default userDataFormES;